export default function React_Components() {
  return (
    <div>
      <h1>React_Components Component</h1>
      <p>This is the React_Components tutorial page.</p>
    </div>
  );
}
